import React, { useEffect, useRef, useState } from "react";
import { HttpMainApi } from "../../interface/main-api";
const mainApi = new HttpMainApi();

const HologramButtonPage: React.FC = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [gamma, setGamma] = useState(0);
  const [beta, setBeta] = useState(0);

  // 자이로센서 이벤트 등록
  useEffect(() => {
    const handleOrientation = (event: DeviceOrientationEvent) => {
      setGamma(event.gamma ?? 0);
      setBeta(event.beta ?? 0);
    };

    if (
      typeof DeviceOrientationEvent !== "undefined" &&
      typeof (DeviceOrientationEvent as any).requestPermission === "function"
    ) {
      (DeviceOrientationEvent as any)
        .requestPermission()
        .then((res: string) => {
          if (res === "granted") {
            window.addEventListener(
              "deviceorientation",
              handleOrientation,
              true
            );
          }
        });
    } else {
      window.addEventListener("deviceorientation", handleOrientation, true);
    }

    return () => {
      window.removeEventListener("deviceorientation", handleOrientation);
    };
  }, []);

  // 기울기 값을 CSS 위치로 변환
  const bgPos = `${50 + gamma}% ${50 + beta}%`;

  const handleClick = async () => {
    try {
      const param: any = {};

      const res = await mainApi.today_check(param);
      console.log("res : ", res);
      alert(res.code);
      // 여기서 res를 기반으로 UI 변경 등 처리 가능
    } catch (err) {
      console.error("API 호출 실패:", err);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        background: "#1a1a1a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        fontFamily: "sans-serif",
      }}
    >
      <button
        ref={buttonRef}
        onClick={handleClick}
        style={{
          position: "relative",
          padding: "1rem 2.5rem",
          fontSize: "1.2rem",
          fontWeight: "bold",
          border: "none",
          borderRadius: "40px",
          color: "#000",
          background: `linear-gradient(
            135deg,
            #fdfdfd,
            #dadada,
            #fef9ff,
            #e1eaff
          )`,
          backgroundSize: "300% 300%",
          backgroundPosition: bgPos,
          transition: "background-position 0.1s ease",
          boxShadow:
            "0 0 20px rgba(255,255,255,0.2), inset 0 0 10px rgba(255,255,255,0.1)",
          overflow: "hidden",
          zIndex: 1,
          cursor: "pointer",
        }}
      >
        {/* 반짝이는 홀로그램 레이어 */}
        <span
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "inherit",
            backgroundImage: `
              url('https://i.imgur.com/7b3Hq0N.gif'),
              conic-gradient(from 180deg, #ff00cc, #00ffee, #ffee00, #ff00cc)
            `,
            backgroundBlendMode: "screen",
            mixBlendMode: "color-dodge",
            backgroundSize: "cover, 300% 300%",
            backgroundPosition: `center, ${bgPos}`,
            filter: "blur(8px) brightness(1.4)",
            opacity: 0.8,
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        <span style={{ position: "relative", zIndex: 1 }}>Hello, world!</span>
      </button>

      {/* 디버깅용 센서 출력 */}
      <div style={{ marginTop: 32, fontSize: "0.9rem", color: "#ccc" }}>
        gamma: {gamma.toFixed(2)}° &nbsp;&nbsp; beta: {beta.toFixed(2)}°
      </div>
    </div>
  );
};

export default HologramButtonPage;
